export default __webpack_public_path__ + "static/media/super-man.29937821.jpg";